module.exports = __webpack_public_path__ + "static/media/19_A.6b8dee13.png";